import { queryOptions, useMutation } from '@tanstack/react-query';
import { axiosGet, axiosPost } from '../utils/api';

export const getSettingByTitle = ({ accessToken, params }) =>
  queryOptions({
    queryKey: ['/settings', params],
    queryFn: async () => {
      const res = await axiosGet('/settings', { params }, accessToken);
      return res.data;
    },
    enabled: !!params?.title,
  });

export const useUpdateSetting = () =>
  useMutation({
    mutationFn: ({ data }) => {
      return axiosPost('/settings', data);
    },
  });
